/* document.addEventListener('DOMContentLoaded', function () { */
	let remainingEl = document.querySelector('.remaining');
	let loadMoreBtn = document.querySelector('.loadmore-btn');
	let anchorLinkBtn = document.querySelector('.anchorLink');
	let postLikeSelector = '.postlike';
	let e = document.querySelector('.grid-home-ag');

	let n = 0, s = 0, o = 0, i = '', c = '', r = '';

	if (e && remainingEl) {
		n = parseInt(remainingEl.getAttribute('data-count'), 10);
		s = parseInt(remainingEl.getAttribute('data-found'), 10);
		o = s;
		i = remainingEl.getAttribute('data-many');
		c = remainingEl.getAttribute('data-one');
		r = remainingEl.getAttribute('data-no');
		updateRemainingText();
	}

	if (loadMoreBtn) {
		loadMoreBtn.addEventListener('click', function () {
			let btn = this;
			let loadPage = btn.getAttribute('data-loadpage');
			let data = {

				action: 'mystic_loadmore',
				loadpage: loadPage
			};

			if (btn.classList.contains('cat')) {
				data.type = 'category';
				data.term_id = btn.getAttribute('data-cat');
			}

			if (btn.classList.contains('search')) {
				data.type = 'search';
				data.search_term = btn.getAttribute('data-search');

			}

			btn.classList.add('loading');

			fetch('https://test.aprendergratis.es/wp-admin/admin-ajax.php', {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: new URLSearchParams(data)
			})
			.then(res => res.text())
			.then(n => {
				btn.setAttribute('data-loadpage', parseInt(loadPage, 10) + 1);
				btn.classList.remove('loading');

				let posts = JSON.parse(n);
				let html = '';
				let firstId = 0;

				posts.data.forEach((a, index) => {
					let article = document.createElement('article');
					article.className = 'components__post-block grid-item';
					if (index === 0) {
						article.id = a.ID;
						firstId = a.ID;
					}

					article.innerHTML = `
						<a href="${a.link}" class="components__post-block__header">
							<h2>${a.post_title}</h2>
							<div class="image-wrapper">
								<div class="components__post-block__header__overlay">
									<i class="fas fa-plus-circle"></i>
								</div>
								<img src="${a.thumbnail}" alt="Aprender Gratis | ${a.post_title}">
							</div>
						</a>
						<div class="components__post-block__excerpt"><p>${a.excerpt}</p></div>
						<div class="components__post-block__actions">
							${a.comment_count > 0 ? `<div>${a.comment_count} <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10px" height="10px" viewBox="0 0 32 32">
					</defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-102.000000, -257.000000)" fill="grey"><path d="M118,257 C109.164,257 102,263.269 102,271 C102,275.419 104.345,279.354 108,281.919 L108,289 L115.009,284.747 C115.979,284.907 116.977,285 118,285 C126.836,285 134,278.732 134,271 C134,263.269 126.836,257 118,257" id="comment-1" sketch:type="MSShapeGroup"></path></g></g></svg>` : ''}
							${a.ratings ? `<div>${a.ratings}</div>` : ''}
						</div>
					`;

					e.innerHTML += article.outerHTML;
				});

				if (firstId) {
					let scrollTo = document.getElementById(firstId);
					if (scrollTo) scrollTo.scrollIntoView();
				}

				updateRemainingText();
			})
			.catch(console.error);
		});
	}

	if (anchorLinkBtn) {
		anchorLinkBtn.addEventListener('click', function () {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});
	}

/* });
 */

function updateRemainingText() {
		o -= n;
		if (o > 0) {
			remainingEl.innerHTML = o + ' ' + (o > 1 ? i : c);
		} else {
			remainingEl.innerHTML = r;
			loadMoreBtn.style.opacity = '0';
		}
	}
